/**
 * Цвет фирменной заглушки для товара без фото. Чередуется по id, чтобы
 * каталог и корзина не превращались в монотонное полотно одного цвета.
 */
export const placeholderTone = (id?: number | string | null): string =>
  typeof id === 'number' && id % 2 === 0 ? 'bg-punch text-white' : 'bg-sun text-ink'
